<template>
  <div>
    <b-sidebar
      id="info-router"
      bg-variant="white"
      backdrop
      shadow
      lazy
      :visible="show"
      right
      @hidden="() => close()"
      width="512px"
      no-header
      :body-class="bodyClass"
    >
      <template #default="{hide}">
        <info-header
          :participantId="currentId"
          :name="item.name"
          :email="item.email"
          :badge_name="item.badge_name"
          :school="item.school"
          :isStatusCheckIn="item.isStatusCheckIn"
          :isStatusCheckOut="item.isStatusCheckOut"
          :mode="stationMode"
          :on-close="hide"
        />
        <template v-if="show">
          <!-- Modo Lead: abas + form dinâmico + rodapé fixo (altura cheia via body-class) -->
          <template v-if="stationMode === 'lead'">
            <info-check-in-lead-form v-if="leadActive" :form="leadForm"/>
            <div v-else class="container-fluid mt-4 text-muted">
              Formulário de coleta de lead não configurado.
            </div>
          </template>

          <!-- Modo Brinde: checklist de brindes (header/progresso/abas fixos, corpo rolável) -->
          <info-brinde v-else-if="stationMode === 'brinde'"/>

          <!-- Modo Check-in: abas no mesmo padrão do lead (header/abas fixos, corpo rolável) -->
          <template v-else>
            <div class="ci-checkin-tabs">
              <button
                type="button"
                class="ci-tab"
                :class="{ active: checkinTab === 'checkin' }"
                @click="checkinTab = 'checkin'"
              >Check-In</button>
              <button
                type="button"
                class="ci-tab"
                :class="{ active: checkinTab === 'detalhes' }"
                @click="checkinTab = 'detalhes'"
              >Detalhes</button>
            </div>
            <div class="ci-checkin-body">
              <div v-show="checkinTab === 'checkin'" class="container-fluid pt-4">
                <info-check-in/>
              </div>
              <div v-show="checkinTab === 'detalhes'" class="container-fluid pt-4">
                <info-detail/>
              </div>
            </div>
          </template>
        </template>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import InfoHeader from '@/modules/check-in/pages/info/info-header'
import InfoCheckIn from '@/modules/check-in/pages/info/info-check-in/index'
import InfoCheckInLeadForm from '@/modules/check-in/pages/info/info-check-in/info-check-in-lead-form'
import InfoBrinde from '@/modules/check-in/pages/info/info-brinde'
import InfoDetail from '@/modules/check-in/pages/info/info-detail'
import { fetchLeadForm } from '@/modules/check-in/service/leadForm'
import { CHECK_IN_MODULE } from '@/modules/check-in'
import { mapActions } from 'vuex'

export default {
  name: 'info',
  components: { InfoDetail, InfoCheckIn, InfoCheckInLeadForm, InfoBrinde, InfoHeader },
  data: () => ({
    leadForm: null,
    checkinTab: 'checkin'
  }),
  mounted () {
    // Carrega o formulário de coleta uma vez (usado no modo Lead).
    fetchLeadForm()
      .then(data => { this.leadForm = data })
      .catch(() => { this.leadForm = null })
  },
  methods: {
    ...mapActions(CHECK_IN_MODULE, ['fetchDetail']),
    close () {
      this.$store.commit(CHECK_IN_MODULE + '/setShowDetailId', null)
    }
  },
  computed: {
    stationMode () {
      return this.$store.getters[CHECK_IN_MODULE + '/stationMode']
    },
    // No modo Lead o corpo da sidebar vira coluna flex (header fixo + form que
    // preenche a altura com corpo rolável e rodapé fixo). Outros modos: padrão.
    bodyClass () {
      // Todos os modos usam o corpo em coluna flex (header/abas fixos, corpo rolável).
      return 'ci-flex-body'
    },
    leadActive () {
      return !!(this.leadForm && this.leadForm.status === true &&
        Array.isArray(this.leadForm.fields) && this.leadForm.fields.length > 0)
    },
    currentId () {
      return this.$store.state[CHECK_IN_MODULE].showDetailId
    },
    show () {
      return !!this.currentId
    },
    item () {
      const item = this.$store.getters[CHECK_IN_MODULE + '/detailById'](this.currentId)
      if (!item) {
        return {
          isStatusCheckIn: false,
          isStatusCheckOut: false,
          name: '',
          badge_name: '',
          school: '',
          email: ''
        }
      }
      return {
        isStatusCheckIn: item.isStatusCheckIn, isStatusCheckOut: item.isStatusCheckOut, name: item.name, badge_name: item.badge_name, school: item.school, email: item.email
      }
    }
  },
  watch: {
    currentId () {
      if (!this.currentId) {
        return
      }
      this.checkinTab = 'checkin'
      this.fetchDetail({ id: this.currentId })
    }
  }
}
</script>

<style scoped>
/* Abas do modo Check-in (mesmo padrão do formulário de lead) */
.ci-checkin-tabs {
  display: flex;
  border-bottom: 1px solid #eef0f4;
}
.ci-tab {
  flex: 1;
  padding: 14px 16px;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #b8bcc8;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}
.ci-tab.active {
  color: rgb(37, 99, 235);
  border-bottom-color: rgb(37, 99, 235);
}
.ci-tab:hover:not(.active) { color: #7b8294; }
</style>

<!-- Não-scoped: nos modos Lead e Check-in o corpo da sidebar vira coluna flex de
     altura cheia (header + abas fixos, corpo rolável). O .b-sidebar-body é gerado
     pelo Bootstrap-Vue; a classe .ci-flex-body é aplicada só nesses modos. -->
<style>
.b-sidebar-body.ci-flex-body {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}
.b-sidebar-body.ci-flex-body > .info-header,
.b-sidebar-body.ci-flex-body > .ci-checkin-tabs {
  flex: 0 0 auto; /* não pode crescer (o .info-header tem flex:1 próprio) */
}
.b-sidebar-body.ci-flex-body > .lead-form,
.b-sidebar-body.ci-flex-body > .info-brinde,
.b-sidebar-body.ci-flex-body > .ci-checkin-body {
  flex: 1 1 auto;
  min-height: 0;
}
.b-sidebar-body.ci-flex-body > .ci-checkin-body {
  overflow-y: auto;
}
.b-sidebar-body.ci-flex-body > .ci-checkin-body::-webkit-scrollbar { width: 4px; }
.b-sidebar-body.ci-flex-body > .ci-checkin-body::-webkit-scrollbar-track { background: transparent; }
.b-sidebar-body.ci-flex-body > .ci-checkin-body::-webkit-scrollbar-thumb { background: #a2adb7; border-radius: 7px; }
</style>
